var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchVolume = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.092 7.953a1 1 0 0 0-1.623-1.17L10.1 8.686 9.066 7.65a3 3 0 0 0-.175-.164 1.3 1.3 0 0 0-.43-.245 1.26 1.26 0 0 0-.78 0 1.3 1.3 0 0 0-.43.245 3 3 0 0 0-.175.164L5.259 9.468a1 1 0 0 0 1.414 1.415L8.07 9.484l1.11 1.111c.042.042.109.108.175.165.081.068.224.178.43.245.254.082.527.082.78 0 .304-.099.517-.32.572-.377l.01-.01.002-.002a1.6 1.6 0 0 0 .16-.188l.002-.002z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16.834 9.167a7.633 7.633 0 0 1-1.585 4.668l2.958 2.958a1 1 0 1 1-1.414 1.414l-2.958-2.958a7.667 7.667 0 1 1 2.999-6.082m-13.334 0a5.667 5.667 0 1 1 9.756 3.923 1 1 0 0 0-.166.166 5.667 5.667 0 0 1-9.59-4.09",
  clipRule: "evenodd"
})));
SvgSearchVolume.displayName = "SvgSearchVolume";
export { SvgSearchVolume as ReactComponent };
export default SvgSearchVolume;